/* Italo Disco Landingpage – 19grams. Kugel, Lichter, Rose, Mixer, Abo-Konfigurator und Disco-Player. */
(function () {
  'use strict';
  var root = document.getElementById('idisco');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  var REDUCE = mq('(prefers-reduced-motion: reduce)').matches;
  var NAME = root.getAttribute('data-name') || 'Italo Disco';

  /* ---------- Shopdaten: kommen live aus Shopify (Liquid schreibt #idisco-data) ---------- */
  function weeksOf(pl) { var m = ((pl.opts || []).join(' ') + ' ' + (pl.name || '')).match(/(\d+)\s*-?\s*week/i); return m ? +m[1] : 0; }
  function monthsOf(pl) { var m = (pl.name || '').match(/charge every (\d+) month/i); return m ? +m[1] : 0; }
  function sizesOf(p) {
    var v = {};
    Object.keys((p && p.v) || {}).forEach(function (sz) { var it = p.v[sz]; if (it && it.available !== false && it.price > 0) v[sz] = it; });
    return v;
  }
  function readData() {
    var el = document.getElementById('idisco-data'), x;
    try { x = el && JSON.parse(el.textContent); } catch (e) { x = null; }
    if (!x || !x.single) return null;
    var D = { cur: x.currency || 'EUR', single: { url: x.single.url, v: sizesOf(x.single) }, plans: {} };
    if (x.unlimited) {
      var u = { url: x.unlimited.url, v: sizesOf(x.unlimited), sp: {}, pp: {}, disc: 0 };
      Object.keys(u.v).forEach(function (sz) {
        (u.v[sz].plans || []).forEach(function (pl) {
          var w = weeksOf(pl); if (!w) return;
          u.sp[w] = pl.id; (u.pp[sz] = u.pp[sz] || {})[w] = pl.price;
          u.disc = Math.max(u.disc, Math.round((1 - pl.price / u.v[sz].price) * 100));
        });
        if (!u.pp[sz]) delete u.v[sz];
      });
      if (Object.keys(u.v).length) D.plans.unlimited = u;
    }
    [['limited6', 6], ['limited12', 12]].forEach(function (k) {
      var p = x[k[0]]; if (!p) return;
      var L = { url: p.url, months: k[1], v: sizesOf(p), sp: null };
      Object.keys(L.v).forEach(function (sz) { var pl = (L.v[sz].plans || [])[0]; if (pl) { L.sp = L.sp || pl.id; L.months = monthsOf(pl) || L.months; } else delete L.v[sz]; });
      if (L.sp && Object.keys(L.v).length) D.plans[k[0]] = L;
    });
    return D;
  }
  var D = readData();
  var MONEY = new Intl.NumberFormat('de-DE', { style: 'currency', currency: (D && D.cur) || 'EUR' });
  var eur = function (cents) { return MONEY.format(cents / 100); };

  /* ---------- Gemeinsamer Zustand für Kugel, Lichter und Beat ---------- */
  var S = { rot: 0.7, speed: 0.32, boost: 0, disco: false, discoMix: 0, pulse: 0, t: 0 };

  /* ---------- Discokugel: WebGL-Spiegelkugel, darüber Faden, Kappe und Glanzsterne ---------- */
  /* Spiegelkugel per WebGL: echte Facetten, Spiegelung von Studio-Licht oben und Tanzfläche unten.
     Liefert null, wenn WebGL fehlt. */
  function makeGLBall(cv, S) {
    'use strict';
    var gl = null;
    try { gl = cv.getContext('webgl', { alpha: true, premultipliedAlpha: true, antialias: false, preserveDrawingBuffer: false }) || cv.getContext('experimental-webgl'); } catch (e) { gl = null; }
    if (!gl) return null;
    var deriv = !!gl.getExtension('OES_standard_derivatives');
    var hi = gl.getShaderPrecisionFormat && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
    var prec = hi && hi.precision > 0 ? 'highp' : 'mediump';

    var VS = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';
    var FS = [
      deriv ? '#extension GL_OES_standard_derivatives : enable' : '',
      'precision ' + prec + ' float;',
      'uniform vec2 uC;uniform float uR;uniform float uRot;uniform float uTilt;uniform float uDisco;uniform float uPulse;uniform float uTime;',
      'uniform vec3 uFloor;uniform vec3 uL[5];uniform vec3 uLc[5];uniform float uLs[5];',
      'const float PI=3.14159265;const float ROWS=22.;const float D=5.;',
      'float h12(vec2 p){vec3 q=fract(vec3(p.xyx)*.1031);q+=dot(q,q.yzx+33.33);return fract((q.x+q.y)*q.z);}',
      'vec3 h32(vec2 p){vec3 q=fract(vec3(p.xyx)*vec3(.1031,.1030,.0973));q+=dot(q,q.yxz+33.33);return fract((q.xxy+q.yzz)*q.zyx);}',
      'vec3 rotV(vec3 v){float c=cos(uRot),s=sin(uRot);v=vec3(c*v.x+s*v.z,v.y,-s*v.x+c*v.z);float ct=cos(uTilt),st=sin(uTilt);return vec3(v.x,ct*v.y-st*v.z,st*v.y+ct*v.z);}',
      'vec3 rotL(vec3 v){float ct=cos(uTilt),st=sin(uTilt);v=vec3(v.x,ct*v.y+st*v.z,-st*v.y+ct*v.z);float c=cos(uRot),s=sin(uRot);return vec3(c*v.x-s*v.z,v.y,s*v.x+c*v.z);}',
      // weiches Rechteck-Licht: Richtung c, halbe Ausdehnung a/b, Kantenweichheit k
      'float panel(vec3 r,vec3 c,vec3 u,float a,float b,float k){float d=dot(r,c);if(d<=0.)return 0.;vec3 v=vec3(cross(c,u));float x=dot(r,v)/d,y=dot(r,u)/d;return (1.-smoothstep(a-k,a+k,abs(x)))*(1.-smoothstep(b-k,b+k,abs(y)));}',
      'vec3 env(vec3 r){',
      '  float y=r.y, day=1.-uDisco;',
      '  float azm=atan(r.x,r.z);',
      '  vec3 up=mix(vec3(.4,.41,.41),vec3(.13,.135,.135),smoothstep(-.05,.95,y));',
      '  up*=.62+.55*smoothstep(-.2,.9,sin(azm*4.+1.3))*smoothstep(.75,.1,y)+.25*smoothstep(.2,1.,sin(azm*9.-.4))*smoothstep(.6,.15,y);',
      '  up+=vec3(.55,.56,.55)*exp(-y*y*55.)*smoothstep(-.6,.4,r.z);',
      '  up*=mix(1.,.16,uDisco);',
      '  vec3 fl=uFloor*vec3(1.,.8,.5)*mix(1.35,.45,smoothstep(0.,.95,-y))*(.93+.14*smoothstep(-.3,.9,sin(azm*3.-.7)));',
      '  fl*=mix(1.,.17,uDisco);',
      // Bohnen spiegeln sich im Gold
      '  vec2 az=normalize(r.xz+1e-4);float bean=smoothstep(.9972,.9988,dot(az,normalize(vec2(-.62,.78))))+smoothstep(.9978,.9991,dot(az,normalize(vec2(.66,.75))));',
      '  bean*=smoothstep(-.02,-.12,y)*smoothstep(-.55,-.3,y);',
      '  fl=mix(fl,vec3(.11,.045,.02),clamp(bean,0.,1.)*.92);',
      // Lichtquadrate auf dem Boden
      '  vec2 g=r.xz/max(-y,.08)*3.2;vec2 gi=floor(g);vec2 gf=fract(g);float sq=step(.62,h12(gi+7.))*step(.18,gf.x)*step(gf.x,.82)*step(.32,gf.y)*step(gf.y,.68);',
      '  fl+=vec3(1.,.95,.8)*sq*.55*smoothstep(-.05,-.2,y)*smoothstep(-.8,-.5,y)*day;',
      '  vec3 col=mix(fl,up,smoothstep(-.012,.012,y));',
      // Studio: Softboxen und Fenster, nur bei Tag
      '  vec3 U=vec3(0.,1.,0.);',
      '  float p=panel(r,normalize(vec3(-.62,.42,.66)),normalize(vec3(.2,.9,-.4)),.42,.22,.012)*2.2;',
      '  p+=panel(r,normalize(vec3(-.95,.12,.1)),U,.18,.55,.01)*1.6;',
      '  p+=panel(r,normalize(vec3(.15,.75,.65)),normalize(vec3(0.,.6,-.8)),.5,.08,.008)*1.3;',
      '  p+=panel(r,normalize(vec3(.92,.22,-.2)),U,.12,.6,.008)*1.8;',
      '  p+=panel(r,normalize(vec3(-.25,.35,-.9)),U,.35,.25,.015)*.9;',
      '  col+=vec3(1.,1.,.98)*p*day;',
      // Punktlichter (Key-Licht und Disco-Spots)
      '  for(int i=0;i<5;i++){float d=max(dot(r,uL[i]),0.);col+=uLc[i]*(pow(d,uLs[i])+pow(d,uLs[i]*.05)*.05);}',
      '  return col;',
      '}',
      'void main(){',
      '  vec2 p=(gl_FragCoord.xy-uC)/uR;float rr=length(p);',
      '  float a=clamp((1.-rr)*uR+.5,0.,1.);if(a<=0.){gl_FragColor=vec4(0.);return;}',
      '  float S=D/sqrt(D*D-1.);vec3 ro=vec3(0.,0.,D);vec3 rd=normalize(vec3(p*S,-D));',
      '  float b=dot(ro,rd),h=max(b*b-(D*D-1.),0.);vec3 P=ro+(-b-sqrt(h))*rd;vec3 N=normalize(P);',
      '  vec3 L=rotL(N);',
      '  float dl=PI/ROWS;float lat=asin(clamp(L.y,-1.,1.));float fr=(lat+.5*PI)/dl;float row=clamp(floor(fr),0.,ROWS-1.);float fv=fr-row;',
      '  float latC=-.5*PI+(row+.5)*dl;float n=max(3.,floor(2.*PI*cos(latC)/dl+.5));',
      '  float lon=atan(L.z,L.x);float off=h12(vec2(row,7.));float fl=lon/(2.*PI)*n+off;float col=floor(fl);float fu=fl-col;col=mod(col,n);',
      '  float lonC=(col+.5-off)/n*2.*PI;',
      '  vec3 Nc=vec3(cos(latC)*cos(lonC),sin(latC),cos(latC)*sin(lonC));',
      '  vec3 jt=h32(vec2(row,col))-.5;Nc=normalize(Nc+jt*.11);',
      '  vec3 Nv=rotV(Nc);vec3 R=reflect(rd,Nv);',
      '  float hv=h12(vec2(col,row)+3.1);',
      '  vec3 c=env(R)*(.8+.28*hv)*(hv<.04?.55:1.);',
      '  c*=vec3(1.,.995,.985)+(h32(vec2(col+2.,row))-.5)*.05;',
      '  c*=1.+(fu-.5)*(h12(vec2(row+5.,col))-.5)*.22+(fv-.5)*.07;',
      // Fugen
      deriv
        ? '  vec3 dx=dFdx(L),dy=dFdy(L);vec3 E=vec3(-sin(lon),0.,cos(lon));vec3 Nn=vec3(-sin(lat)*cos(lon),cos(lat),-sin(lat)*sin(lon));float cl=max(cos(lat),.05);float fwu=(abs(dot(dx,E))+abs(dot(dy,E)))*n/(2.*PI*cl);float fwv=(abs(dot(dx,Nn))+abs(dot(dy,Nn)))/dl;'
        : '  float fwu=1.4/(uR*dl*max(N.z,.15));float fwv=fwu;',
      '  float eu=min(fu,1.-fu),ev=min(fv,1.-fv);',
      '  float m=smoothstep(.02-fwu,.02+fwu,eu)*smoothstep(.028-fwv,.028+fwv,ev);',
      '  vec3 Rs=reflect(rd,N);vec3 e=env(Rs);float lum=dot(min(e,vec3(1.5)),vec3(.3,.5,.2));',
      '  vec3 gap=mix(vec3(.06),vec3(.7,.68,.64)*(.3+.7*lum),.6);gap=mix(gap,e*.2,uDisco);',
      '  c=mix(gap,c,m);',
      // leichte Abdunklung am Rand, wie bei echter Glasfacette
      '  c*=mix(.82,1.,smoothstep(0.,.35,N.z));',
      '  c=(c*(2.51*c+.03))/(c*(2.43*c+.59)+.14);',
      '  c=pow(clamp(c,0.,1.),vec3(1./2.2));',
      '  gl_FragColor=vec4(c*a,a);',
      '}'
    ].join('\n');

    function sh(type, src) {
      var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) { var log = gl.getShaderInfoLog(s); gl.deleteShader(s); throw new Error(log); }
      return s;
    }
    var prog;
    try {
      prog = gl.createProgram();
      gl.attachShader(prog, sh(gl.VERTEX_SHADER, VS)); gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, FS));
      gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(prog));
    } catch (e) { if (window.console) console.warn('idisco ball', e); return null; }
    gl.useProgram(prog);
    var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(prog, 'a'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    var U = {};
    ['uC', 'uR', 'uRot', 'uTilt', 'uDisco', 'uPulse', 'uTime', 'uFloor', 'uL', 'uLc', 'uLs'].forEach(function (n) { U[n] = gl.getUniformLocation(prog, n); });

    function nrm(x, y, z) { var l = Math.sqrt(x * x + y * y + z * z); return [x / l, y / l, z / l]; }
    function lin(c) { return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
    var FLOOR = [lin(230 / 255), lin(189 / 255), lin(105 / 255)];
    var KEY = nrm(0.5, 0.26, 0.83);

    var W = 0, H = 0, dpr = 1, size = 0;
    function resize() {
      var r = cv.getBoundingClientRect(); if (!r.width) return;
      dpr = Math.min(window.devicePixelRatio || 1, 2); size = r.width;
      W = Math.round(r.width * dpr); H = Math.round(r.height * dpr);
      if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; }
      gl.viewport(0, 0, W, H);
    }
    // Lichter: [Richtung, Farbe, Schärfe]
    var lights = [[KEY, [0, 0, 0], 1400], [KEY, [0, 0, 0], 300], [KEY, [0, 0, 0], 300], [KEY, [0, 0, 0], 300], [KEY, [0, 0, 0], 300]];
    var SPOTC = [[1, 0.37, 0.66], [0.34, 0.89, 0.91], [1, 0.84, 0.47], [0.7, 0.55, 1]];
    function setLights(t) {
      var dsc = S.disco ? 1 : 0, k = S.discoMix;
      var keyI = (1 - k) * 28 + k * 18 * (0.55 + 0.9 * S.pulse);
      lights[0][0] = KEY; lights[0][1] = [keyI, keyI * 0.98, keyI * 0.94]; lights[0][2] = 1400;
      for (var i = 0; i < 4; i++) {
        var a = t * (0.35 + i * 0.07) * (i % 2 ? -1 : 1) + i * 1.57;
        var el = 0.25 + 0.35 * Math.sin(t * 0.21 + i * 2.1);
        var d = nrm(Math.cos(a), el, Math.abs(Math.sin(a)) * 0.9 + 0.25);
        var inten = k * 9 * (0.45 + 1.1 * S.pulse);
        lights[i + 1][0] = d; lights[i + 1][1] = [SPOTC[i][0] * inten, SPOTC[i][1] * inten, SPOTC[i][2] * inten]; lights[i + 1][2] = 420;
      }
      return dsc;
    }
    var cX = 0.5, cY = 0.56, rF = 0.38;
    function draw() {
      if (!W) resize(); if (!W) return;
      setLights(S.t);
      gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT);
      gl.uniform2f(U.uC, W * cX, H * (1 - cY));
      gl.uniform1f(U.uR, W * rF);
      gl.uniform1f(U.uRot, S.rot);
      gl.uniform1f(U.uTilt, 0.2);
      gl.uniform1f(U.uDisco, S.discoMix);
      gl.uniform1f(U.uPulse, S.pulse);
      gl.uniform1f(U.uTime, S.t);
      gl.uniform3f(U.uFloor, FLOOR[0], FLOOR[1], FLOOR[2]);
      var Ld = [], Lc = [], Ls = [];
      for (var i = 0; i < 5; i++) { Ld.push.apply(Ld, lights[i][0]); Lc.push.apply(Lc, lights[i][1]); Ls.push(lights[i][2]); }
      gl.uniform3fv(U.uL, new Float32Array(Ld)); gl.uniform3fv(U.uLc, new Float32Array(Lc)); gl.uniform1fv(U.uLs, new Float32Array(Ls));
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }
    // Glanzpunkte: wo spiegelt eine Facette gerade ein Licht ins Auge?
    function hotspots() {
      var out = [];
      for (var i = 0; i < 5; i++) {
        var c = lights[i][1], I = (c[0] + c[1] + c[2]) / 3; if (I < 0.6) continue;
        var L = lights[i][0], h = nrm(L[0], L[1], L[2] + 1);
        if (h[2] < 0.15) continue;
        out.push({ x: cX + h[0] * rF, y: cY - h[1] * rF, c: c, i: I, k: i });
      }
      return out;
    }
    return { gl: true, resize: resize, draw: draw, hotspots: hotspots, geom: { cx: cX, cy: cY, r: rF } };
  }
  function makeBall(stage) {
    var glc = stage.querySelector('.id-ball-gl'), fxc = stage.querySelector('.id-ball-fx'), still = stage.querySelector('.id-ball-still');
    var glb = null;
    try { glb = makeGLBall(glc, S); } catch (e) { glb = null; }
    function useStill() { glb = null; glc.hidden = true; still.hidden = false; }
    if (glb) { still.hidden = true; glc.addEventListener('webglcontextlost', function (e) { e.preventDefault(); useStill(); }); }
    else useStill();
    var g = fxc.getContext('2d'), size = 0, dpr = 1, sparks = [];
    var G = { cx: 0.5, cy: 0.56, r: 0.38 };
    function nrm(x, y, z) { var l = Math.sqrt(x * x + y * y + z * z); return [x / l, y / l, z / l]; }
    var KEY = nrm(0.5, 0.26, 0.83), KH = nrm(KEY[0], KEY[1], KEY[2] + 1);
    function resize() {
      var r = fxc.getBoundingClientRect(); if (!r.width) return;
      dpr = Math.min(window.devicePixelRatio || 1, 2); size = r.width;
      fxc.width = Math.round(size * dpr); fxc.height = Math.round(size * dpr);
      if (glb) glb.resize();
    }
    function star(x, y, s, col, I, rays) {
      if (I <= 0.01) return;
      var gr = g.createRadialGradient(x, y, 0, x, y, s * 0.5);
      gr.addColorStop(0, 'rgba(255,255,255,' + (0.95 * I).toFixed(3) + ')');
      gr.addColorStop(0.2, 'rgba(' + col + ',' + (0.5 * I).toFixed(3) + ')');
      gr.addColorStop(1, 'rgba(' + col + ',0)');
      g.fillStyle = gr; g.beginPath(); g.arc(x, y, s * 0.5, 0, 6.2832); g.fill();
      for (var i = 0; i < rays.length; i++) {
        var L = s * rays[i][1], w = Math.max(0.8, s * 0.03 * rays[i][1]);
        g.save(); g.translate(x, y); g.rotate(rays[i][0]);
        var lg = g.createLinearGradient(-L, 0, L, 0);
        lg.addColorStop(0, 'rgba(' + col + ',0)'); lg.addColorStop(0.5, 'rgba(255,255,255,' + (0.9 * I).toFixed(3) + ')'); lg.addColorStop(1, 'rgba(' + col + ',0)');
        g.fillStyle = lg; g.beginPath(); g.moveTo(-L, 0); g.lineTo(0, -w); g.lineTo(L, 0); g.lineTo(0, w); g.closePath(); g.fill();
        g.restore();
      }
    }
    var RAYS = [[0.12, 1], [0.12 + Math.PI / 2, 1], [0.12 + Math.PI / 4, 0.45], [0.12 - Math.PI / 4, 0.45]];
    var SMALL = [[0.3, 1], [0.3 + Math.PI / 2, 1]];
    function draw(dt) {
      if (!size) resize(); if (!size) return;
      if (glb) glb.draw();
      var cx = G.cx * size, cy = G.cy * size, R = G.r * size, dm = S.discoMix;
      g.setTransform(dpr, 0, 0, dpr, 0, 0); g.clearRect(0, 0, size, size);
      var top = cy - R - R * 0.05;
      var sg = g.createLinearGradient(cx - 1.2, 0, cx + 1.2, 0);
      sg.addColorStop(0, '#4f5559'); sg.addColorStop(0.5, dm > 0.5 ? '#f3d48e' : '#e7ebed'); sg.addColorStop(1, '#4f5559');
      g.fillStyle = sg; g.fillRect(cx - 1.2, 0, 2.4, top + 1);
      var cw = R * 0.17, ch = R * 0.08, x0 = cx - cw / 2, y0 = top - ch * 0.35;
      var cg = g.createLinearGradient(x0, 0, x0 + cw, 0);
      cg.addColorStop(0, '#6c7277'); cg.addColorStop(0.32, '#f5f7f8'); cg.addColorStop(0.62, '#aeb3b7'); cg.addColorStop(1, '#5a6064');
      g.fillStyle = cg; g.beginPath();
      if (g.roundRect) g.roundRect(x0, y0, cw, ch, ch * 0.3); else g.rect(x0, y0, cw, ch);
      g.fill();
      g.fillStyle = 'rgba(0,0,0,.28)'; g.fillRect(x0, y0 + ch * 0.68, cw, ch * 0.14);
      g.globalCompositeOperation = 'lighter';
      var hs = glb ? glb.hotspots() : [{ x: G.cx + KH[0] * G.r, y: G.cy - KH[1] * G.r, c: [28, 27, 26], i: 27, k: 0 }];
      for (var i = 0; i < hs.length; i++) {
        var h = hs[i], c = h.c, m = Math.max(c[0], c[1], c[2]) || 1;
        var col = Math.round(255 * c[0] / m) + ',' + Math.round(255 * c[1] / m) + ',' + Math.round(255 * c[2] / m);
        var tw = glb ? Math.pow(0.5 + 0.5 * Math.cos(S.rot * 44 + h.k * 1.7), 6) : 0.5 + 0.5 * Math.sin(S.t * 2.3);
        var I = Math.min(1, h.i / 20) * (0.3 + 0.7 * tw);
        star(h.x * size, h.y * size, R * (0.55 + 0.3 * I), col, I, RAYS);
      }
      if (sparks.length < 6 && Math.random() < (S.disco ? 0.14 : 0.05)) {
        var a = Math.random() * 6.2832, rr = Math.sqrt(Math.random()) * R * 0.85;
        var sy = cy + Math.sin(a) * rr; if (Math.random() < 0.65 && sy > cy) sy = cy - (sy - cy);
        sparks.push({ x: cx + Math.cos(a) * rr, y: sy, life: 1, s: R * (0.16 + Math.random() * 0.16) });
      }
      for (var k = sparks.length - 1; k >= 0; k--) {
        var p = sparks[k]; p.life -= dt * 2.2;
        if (p.life <= 0) { sparks.splice(k, 1); continue; }
        star(p.x, p.y, p.s, '255,246,224', Math.sin(p.life * Math.PI) * 0.8, SMALL);
      }
      g.globalCompositeOperation = 'source-over';
    }
    function burst() {
      var cx = G.cx * size, cy = G.cy * size, R = G.r * size;
      for (var i = 0; i < 10; i++) {
        var a = Math.random() * 6.2832, rr = Math.sqrt(Math.random()) * R * 0.9;
        sparks.push({ x: cx + Math.cos(a) * rr, y: cy + Math.sin(a) * rr, life: 1, s: R * (0.2 + Math.random() * 0.2) });
      }
    }
    return { resize: resize, draw: draw, burst: burst, isGL: function () { return !!glb; } };
  }

  /* ---------- Lichtpunkte über der Seite ---------- */
  function makeSpots(cv) {
    var g = cv.getContext('2d'), W = 0, H = 0, dpr = 1, clear = true;
    var COLORS = ['#ffffff', '#fff1c9', '#ff5fa8', '#56e2e9', '#e6bd69', '#a7f0b9', '#b48cff'];
    var sprites = COLORS.map(function (c) {
      var s = document.createElement('canvas'); s.width = s.height = 64;
      var x = s.getContext('2d'), gr = x.createRadialGradient(32, 32, 0, 32, 32, 32);
      gr.addColorStop(0, 'rgba(255,255,255,1)'); gr.addColorStop(0.32, c); gr.addColorStop(1, 'rgba(0,0,0,0)');
      x.fillStyle = gr; x.beginPath(); x.arc(32, 32, 32, 0, 6.2832); x.fill();
      return s;
    });
    var N = 48, spots = [];
    for (var i = 0; i < N; i++) spots.push({ a: Math.random() * 6.283, e: Math.random() * 2 - 1, s: 4 + Math.random() * 9, c: i % COLORS.length, tw: Math.random() * 6.283, sp: 0.8 + Math.random() * 0.4 });
    function resize() {
      dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      W = window.innerWidth; H = window.innerHeight;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      clear = true;
    }
    function draw(visible) {
      if (!W) resize();
      g.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (!visible) { if (!clear) { g.clearRect(0, 0, W, H); clear = true; } return; }
      g.clearRect(0, 0, W, H); clear = false;
      var rect = root.getBoundingClientRect(), top = Math.max(0, rect.top), bot = Math.min(H, rect.bottom);
      if (bot <= top) return;
      g.save(); g.beginPath(); g.rect(0, top, W, bot - top); g.clip();
      var disco = S.disco, count = disco ? N : 26, base = disco ? 0.55 : 0.3, pulse = disco ? 0.6 + 0.8 * S.pulse : 1;
      for (var i = 0; i < count; i++) {
        var p = spots[i], ang = p.a + S.rot * p.sp;
        var u = (((ang % 6.2832) + 6.2832) % 6.2832) / 6.2832;
        var x = -0.15 * W + u * 1.3 * W, y = H * 0.5 + p.e * H * 0.52 + Math.sin(ang * 1.7 + p.tw) * 14;
        var tw = 0.55 + 0.45 * Math.sin(S.t * 2.6 + p.tw);
        var s = p.s * (disco ? 1.5 + 0.35 * S.pulse : 1);
        var ci = disco ? p.c : (p.c === 2 || p.c === 4 ? p.c : (p.c % 2));
        g.globalAlpha = Math.min(1, base * tw * pulse);
        g.drawImage(sprites[ci], x - s, y - s, s * 2, s * 2);
      }
      g.restore(); g.globalAlpha = 1;
    }
    return { resize: resize, draw: draw };
  }

  /* ---------- Lichtquadrate auf der Tanzfläche (wie auf der Tüte) ---------- */
  function makeFloor(cv) {
    var g = cv.getContext('2d'), W = 0, H = 0, dpr = 1, Q = [];
    var COL = ['255,255,255', '255,250,232', '255,95,168', '86,226,233', '255,214,120'];
    for (var i = 0; i < 150; i++) Q.push({ a: Math.random() * 6.283, r: 0.16 + Math.sqrt(Math.random()) * 0.92, s: 0.6 + Math.random() * 0.8, tw: Math.random() * 6.283, c: Math.floor(Math.random() * 5) });
    function resize() {
      var r = cv.getBoundingClientRect(); if (!r.width) return;
      dpr = Math.min(window.devicePixelRatio || 1, 2); W = r.width; H = r.height;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    }
    function draw() {
      if (!W) resize(); if (!W) return;
      g.setTransform(dpr, 0, 0, dpr, 0, 0); g.clearRect(0, 0, W, H);
      var cx = W / 2, cy = H * 0.4, rx = Math.min(W * 0.5, 640), ry = H * 0.36, small = W < 560 ? 0.8 : 1;
      for (var i = 0; i < Q.length; i++) {
        var q = Q[i], ang = q.a + S.rot * 0.9;
        var x = cx + Math.cos(ang) * q.r * rx, y = cy + Math.sin(ang) * q.r * ry;
        var depth = (Math.sin(ang) * 0.5 + 0.5) * 0.6 + 0.4;
        var w = (4 + 6 * q.s) * depth * small, h = w * 0.45;
        var tw = 0.55 + 0.45 * Math.sin(S.t * 3 + q.tw);
        var col = S.disco ? COL[q.c] : (q.c < 2 ? COL[q.c] : COL[1]);
        g.fillStyle = 'rgba(' + col + ',' + ((S.disco ? 0.9 : 0.62) * tw * depth).toFixed(3) + ')';
        g.fillRect(x - w / 2, y - h / 2, w, h);
      }
    }
    return { resize: resize, draw: draw };
  }

  /* ---------- Musik: eigener Italo-Groove, live im Browser erzeugt ---------- */
  var Music = (function () {
    var AC = window.AudioContext || window.webkitAudioContext;
    var ctx = null, out, comp, an, anData, bus, dly, dfb, dlp, dret, verb, vret, noise;
    var playing = false, ti = 0, step = 0, nextT = 0, t0 = 0, timer = null, loops = 0, onTrack = null;
    var TR = [
      { name: 'Crema Fantasia', bpm: 118, roots: [33, 29, 36, 31],
        chords: [[57, 60, 64], [53, 57, 60], [55, 60, 64], [55, 59, 62]],
        bass: [0, -1, 1, -1, 0, -1, 1, -1, 0, -1, 1, -1, 0, -1, 1, 1],
        arp: [0, 1, 2, 3, 2, 1, 0, 1, 0, 1, 2, 3, 2, 1, 2, 1],
        lead: [
          [[0, 76, 3], [4, 74, 2], [6, 72, 2], [8, 74, 3], [12, 76, 4]],
          [[0, 72, 3], [4, 69, 2], [6, 72, 2], [8, 77, 4], [12, 76, 2], [14, 74, 2]],
          [[0, 76, 3], [4, 79, 3], [8, 76, 2], [10, 74, 2], [12, 72, 4]],
          [[0, 74, 6], [8, 71, 2], [10, 72, 2], [12, 74, 4]],
          [[0, 76, 3], [4, 81, 3], [8, 79, 2], [10, 76, 2], [12, 74, 2], [14, 72, 2]],
          [[0, 72, 3], [4, 77, 2], [6, 76, 2], [8, 74, 4], [12, 72, 2], [14, 69, 2]],
          [[0, 67, 2], [2, 72, 2], [4, 76, 4], [8, 79, 4], [12, 76, 4]],
          [[0, 74, 4], [4, 71, 4], [8, 69, 8]]
        ] },
      { name: 'Notte di Moka', bpm: 122, roots: [38, 34, 41, 36],
        chords: [[57, 62, 65], [58, 62, 65], [57, 60, 65], [55, 60, 64]],
        bass: [0, -1, 0, 1, 0, -1, 0, 1, 0, -1, 0, 1, 0, -1, 1, 1],
        arp: [0, 2, 1, 3, 0, 2, 1, 3, 0, 2, 1, 3, 2, 1, 0, 1],
        lead: [
          [[0, 69, 2], [2, 74, 2], [4, 77, 4], [8, 76, 2], [10, 74, 2], [12, 76, 4]],
          [[0, 77, 2], [2, 74, 2], [4, 70, 4], [8, 72, 2], [10, 74, 2], [12, 77, 4]],
          [[0, 81, 4], [4, 79, 2], [6, 77, 2], [8, 76, 2], [10, 77, 2], [12, 79, 4]],
          [[0, 76, 6], [8, 72, 2], [10, 74, 2], [12, 76, 2], [14, 79, 2]],
          [[0, 77, 4], [4, 76, 2], [6, 74, 2], [8, 69, 4], [12, 74, 4]],
          [[0, 74, 2], [2, 77, 2], [4, 82, 4], [8, 81, 2], [10, 79, 2], [12, 77, 4]],
          [[0, 72, 2], [2, 77, 2], [4, 81, 4], [8, 79, 2], [10, 77, 2], [12, 76, 2], [14, 77, 2]],
          [[0, 79, 4], [4, 76, 4], [8, 74, 8]]
        ] },
      { name: 'Vollautomatico', bpm: 120, roots: [40, 36, 38, 35],
        chords: [[55, 59, 64], [55, 60, 64], [57, 62, 66], [54, 59, 62]],
        bass: [0, -1, 1, -1, 0, -1, 1, 0, -1, 0, 1, -1, 0, -1, 1, -1],
        arp: [0, 1, 2, 1, 3, 1, 2, 1, 0, 1, 2, 1, 3, 2, 1, 2],
        lead: [
          [[0, 71, 2], [2, 76, 2], [4, 79, 2], [6, 78, 2], [8, 76, 4], [12, 71, 4]],
          [[0, 72, 2], [2, 76, 2], [4, 79, 4], [8, 81, 2], [10, 79, 2], [12, 76, 4]],
          [[0, 78, 4], [4, 81, 2], [6, 78, 2], [8, 74, 4], [12, 76, 2], [14, 78, 2]],
          [[0, 74, 4], [4, 71, 4], [8, 78, 8]],
          [[0, 79, 2], [2, 78, 2], [4, 76, 2], [6, 71, 2], [8, 76, 2], [10, 79, 2], [12, 83, 4]],
          [[0, 81, 4], [4, 79, 2], [6, 76, 2], [8, 72, 4], [12, 76, 4]],
          [[0, 74, 2], [2, 78, 2], [4, 81, 4], [8, 79, 2], [10, 78, 2], [12, 74, 4]],
          [[0, 78, 4], [4, 74, 4], [8, 76, 8]]
        ] }
    ];
    function mtof(m) { return 440 * Math.pow(2, (m - 69) / 12); }
    function impulse(sec) {
      var len = Math.floor(ctx.sampleRate * sec), buf = ctx.createBuffer(2, len, ctx.sampleRate);
      for (var c = 0; c < 2; c++) { var d = buf.getChannelData(c); for (var i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 3.2); }
      return buf;
    }
    function build() {
      ctx = new AC();
      out = ctx.createGain(); out.gain.value = 0;
      comp = ctx.createDynamicsCompressor();
      comp.threshold.value = -16; comp.knee.value = 10; comp.ratio.value = 4; comp.attack.value = 0.003; comp.release.value = 0.18;
      an = ctx.createAnalyser(); an.fftSize = 64; anData = new Uint8Array(an.frequencyBinCount);
      out.connect(comp); comp.connect(an); an.connect(ctx.destination);
      bus = ctx.createGain(); bus.gain.value = 0.9; bus.connect(out);
      dly = ctx.createDelay(1.5); dfb = ctx.createGain(); dfb.gain.value = 0.32;
      dlp = ctx.createBiquadFilter(); dlp.type = 'lowpass'; dlp.frequency.value = 2400;
      dret = ctx.createGain(); dret.gain.value = 0.45;
      dly.connect(dlp); dlp.connect(dfb); dfb.connect(dly); dlp.connect(dret); dret.connect(out);
      verb = ctx.createConvolver(); verb.buffer = impulse(2.2); vret = ctx.createGain(); vret.gain.value = 0.26;
      verb.connect(vret); vret.connect(out);
      noise = ctx.createBuffer(1, ctx.sampleRate, ctx.sampleRate);
      var nd = noise.getChannelData(0); for (var i = 0; i < nd.length; i++) nd[i] = Math.random() * 2 - 1;
    }
    function send(node, dest, amt) { var s = ctx.createGain(); s.gain.value = amt; node.connect(s); s.connect(dest); }
    function noiseSrc(t, dur) { var n = ctx.createBufferSource(); n.buffer = noise; n.start(t, Math.random() * 0.5, dur); return n; }
    function kick(t) {
      var o = ctx.createOscillator(), g = ctx.createGain();
      o.type = 'sine'; o.frequency.setValueAtTime(160, t); o.frequency.exponentialRampToValueAtTime(46, t + 0.11);
      g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.95, t + 0.003); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.42);
      o.connect(g); g.connect(bus); o.start(t); o.stop(t + 0.45);
      var n = noiseSrc(t, 0.02), hp = ctx.createBiquadFilter(), ng = ctx.createGain();
      hp.type = 'highpass'; hp.frequency.value = 3000;
      ng.gain.setValueAtTime(0.16, t); ng.gain.exponentialRampToValueAtTime(0.0001, t + 0.012);
      n.connect(hp); hp.connect(ng); ng.connect(bus);
    }
    function clap(t) {
      var n = noiseSrc(t, 0.3), bp = ctx.createBiquadFilter(), g = ctx.createGain();
      bp.type = 'bandpass'; bp.frequency.value = 1150; bp.Q.value = 0.8;
      g.gain.setValueAtTime(0.0001, t);
      [0, 0.012, 0.024].forEach(function (o) { g.gain.setValueAtTime(0.5, t + o); g.gain.exponentialRampToValueAtTime(0.06, t + o + 0.0105); });
      g.gain.setValueAtTime(0.45, t + 0.036); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.24);
      n.connect(bp); bp.connect(g); g.connect(bus); send(g, verb, 0.35);
    }
    function hat(t, open, v) {
      var dur = open ? 0.2 : 0.035, n = noiseSrc(t, dur + 0.02), hp = ctx.createBiquadFilter(), g = ctx.createGain();
      hp.type = 'highpass'; hp.frequency.value = 7200;
      g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.19 * v, t + 0.002); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      n.connect(hp); hp.connect(g); g.connect(bus);
    }
    function tom(t, f) {
      var o = ctx.createOscillator(), g = ctx.createGain();
      o.type = 'triangle'; o.frequency.setValueAtTime(f, t); o.frequency.exponentialRampToValueAtTime(f * 0.55, t + 0.22);
      g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.45, t + 0.004); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.3);
      o.connect(g); g.connect(bus); send(g, verb, 0.3); o.start(t); o.stop(t + 0.32);
    }
    function bass(t, m, dur) {
      var f = mtof(m), o1 = ctx.createOscillator(), o2 = ctx.createOscillator(), mix = ctx.createGain(), lp = ctx.createBiquadFilter(), g = ctx.createGain();
      o1.type = 'sawtooth'; o2.type = 'square'; o1.frequency.value = f; o2.frequency.value = f; o2.detune.value = -6; mix.gain.value = 0.45;
      lp.type = 'lowpass'; lp.Q.value = 6; lp.frequency.setValueAtTime(1700, t); lp.frequency.exponentialRampToValueAtTime(260, t + Math.max(0.06, dur));
      g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.34, t + 0.005); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o1.connect(lp); o2.connect(mix); mix.connect(lp); lp.connect(g); g.connect(bus);
      o1.start(t); o2.start(t); o1.stop(t + dur + 0.02); o2.stop(t + dur + 0.02);
    }
    function pluck(t, m, dur) {
      var o = ctx.createOscillator(), lp = ctx.createBiquadFilter(), g = ctx.createGain();
      o.type = 'square'; o.frequency.value = mtof(m);
      lp.type = 'lowpass'; lp.frequency.setValueAtTime(4200, t); lp.frequency.exponentialRampToValueAtTime(900, t + dur);
      g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.065, t + 0.004); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.connect(lp); lp.connect(g); g.connect(bus); send(g, dly, 0.5);
      o.start(t); o.stop(t + dur + 0.02);
    }
    function pad(t, notes, dur) {
      notes.forEach(function (m) {
        [-9, 9].forEach(function (dt) {
          var o = ctx.createOscillator(), lp = ctx.createBiquadFilter(), g = ctx.createGain();
          o.type = 'sawtooth'; o.frequency.value = mtof(m); o.detune.value = dt;
          lp.type = 'lowpass'; lp.frequency.value = 1500; lp.Q.value = 0.4;
          g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.028, t + 0.35);
          g.gain.setValueAtTime(0.028, t + dur - 0.05); g.gain.exponentialRampToValueAtTime(0.0001, t + dur + 0.4);
          o.connect(lp); lp.connect(g); g.connect(bus); send(g, verb, 0.6);
          o.start(t); o.stop(t + dur + 0.45);
        });
      });
    }
    function lead(t, m, dur) {
      var f = mtof(m), o1 = ctx.createOscillator(), o2 = ctx.createOscillator(), lfo = ctx.createOscillator(), lg = ctx.createGain(), lp = ctx.createBiquadFilter(), g = ctx.createGain();
      o1.type = 'sawtooth'; o2.type = 'square'; o1.frequency.value = f; o2.frequency.value = f; o2.detune.value = 7;
      lfo.frequency.value = 5.6; lg.gain.setValueAtTime(0, t); lg.gain.linearRampToValueAtTime(f * 0.006, t + Math.min(0.25, dur));
      lfo.connect(lg); lg.connect(o1.frequency); lg.connect(o2.frequency);
      lp.type = 'lowpass'; lp.frequency.value = 3200; lp.Q.value = 1.5;
      var v = 0.1;
      g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(v, t + 0.012);
      g.gain.setValueAtTime(v, t + Math.max(0.03, dur - 0.03)); g.gain.exponentialRampToValueAtTime(0.0001, t + dur + 0.12);
      o1.connect(lp); o2.connect(lp); lp.connect(g); g.connect(bus); send(g, dly, 0.36); send(g, verb, 0.3);
      [o1, o2, lfo].forEach(function (o) { o.start(t); o.stop(t + dur + 0.15); });
    }
    function sched(s, t) {
      var tr = TR[ti], spb = 60 / tr.bpm, st = s % 16, bar = Math.floor(s / 16) % 16, ci = bar % 4, ch = tr.chords[ci];
      if (st % 4 === 0) kick(t);
      if (st === 4 || st === 12) clap(t);
      if (st % 2 === 0) hat(t, st % 4 === 2, st % 4 === 2 ? 0.8 : 0.45); else hat(t, false, 0.28);
      if ((bar === 7 || bar === 15) && st >= 12) tom(t, [220, 185, 155, 130][st - 12]);
      var bp = tr.bass[st];
      if (bp >= 0) bass(t, tr.roots[ci] + (bp ? 12 : 0), spb / 4 * 0.85);
      if (bar < 8 || bar >= 12) { var idx = tr.arp[st]; pluck(t, ch[idx % 3] + 12 + (idx === 3 ? 12 : 0), spb / 4 * 0.9); }
      if (st === 0 && bar >= 4) pad(t, ch, spb * 4);
      if (bar >= 8) { var ph = tr.lead[bar - 8]; for (var i = 0; i < ph.length; i++) if (ph[i][0] === st) lead(t, ph[i][1], ph[i][2] * spb / 4 * 0.92); }
    }
    function tick() {
      if (!playing) return;
      var spb = 60 / TR[ti].bpm;
      while (nextT < ctx.currentTime + 0.12) {
        sched(step, nextT);
        nextT += spb / 4; step++;
        if (step >= 256) { step = 0; loops++; if (loops >= 3) { setTrack((ti + 1) % TR.length); return; } }
      }
    }
    function setTrack(i) {
      ti = i; step = 0; loops = 0;
      var tr = TR[ti];
      if (ctx) { dly.delayTime.setValueAtTime(0.75 * 60 / tr.bpm, ctx.currentTime); nextT = ctx.currentTime + 0.06; t0 = nextT; }
      if (onTrack) onTrack(tr);
    }
    return {
      supported: !!AC,
      tracks: TR,
      current: function () { return TR[ti]; },
      onTrack: function (fn) { onTrack = fn; },
      isPlaying: function () { return playing; },
      start: function () {
        if (!AC) return false;
        try { if (!ctx) build(); } catch (e) { return false; }
        try { if (navigator.audioSession) navigator.audioSession.type = 'playback'; } catch (e) { /* optional */ }
        if (ctx.state !== 'running' && ctx.resume) ctx.resume();
        var now = ctx.currentTime;
        out.gain.cancelScheduledValues(now); out.gain.setValueAtTime(out.gain.value, now); out.gain.linearRampToValueAtTime(0.85, now + 0.4);
        playing = true; setTrack(ti);
        clearInterval(timer); timer = setInterval(tick, 25); tick();
        return true;
      },
      stop: function () {
        if (!ctx || !playing) { playing = false; return; }
        playing = false; clearInterval(timer); timer = null;
        var now = ctx.currentTime;
        out.gain.cancelScheduledValues(now); out.gain.setValueAtTime(out.gain.value, now); out.gain.linearRampToValueAtTime(0, now + 0.25);
        setTimeout(function () { if (!playing && ctx.suspend) ctx.suspend(); }, 320);
      },
      next: function () { if (playing) setTrack((ti + 1) % TR.length); else { ti = (ti + 1) % TR.length; if (onTrack) onTrack(TR[ti]); } },
      phase: function () {
        if (!playing || !ctx) return 0;
        var x = (ctx.currentTime - (ctx.outputLatency || ctx.baseLatency || 0) - t0) * TR[ti].bpm / 60;
        return x < 0 ? 0 : x - Math.floor(x);
      },
      levels: function (arr) {
        if (!an) return arr;
        an.getByteFrequencyData(anData);
        var bands = [[1, 2], [3, 5], [6, 10], [11, 20]];
        for (var b = 0; b < 4; b++) { var s = 0, c = 0; for (var i = bands[b][0]; i <= bands[b][1]; i++) { s += anData[i]; c++; } arr[b] = s / c / 255; }
        return arr;
      }
    };
  })();

  /* ---------- Hero und Lichter verdrahten ---------- */
  var floorCv = $('.id-floorlights'), spotsCv = $('.id-spots');
  var ball = makeBall($('.id-ballstage')), floor = makeFloor(floorCv), spots = makeSpots(spotsCv);
  var beans = $$('.id-bean');
  var hero = $('.id-hero');
  var heroVis = true, rootVis = true, raf = 0, last = 0;

  function bounce(ph) {
    for (var i = 0; i < beans.length; i++) {
      var b = 0;
      if (ph >= 0) { var p = (ph + (i % 2) * 0.5) % 1; b = 20 * Math.pow(Math.sin(p * Math.PI), 0.85); }
      beans[i].style.setProperty('--b', b.toFixed(1));
    }
  }
  var bars = $$('.id-pl-bars i'), lv = [0, 0, 0, 0];
  function playerBars() {
    if (Music.isPlaying()) Music.levels(lv); else { lv[0] = lv[1] = lv[2] = lv[3] = 0; }
    for (var i = 0; i < bars.length; i++) bars[i].style.setProperty('--h', Math.min(1, lv[i] * 1.25).toFixed(2));
  }
  function frame(now) {
    raf = 0;
    if (document.hidden) return;
    var dt = last ? Math.min(0.05, (now - last) / 1000) : 0.016; last = now;
    S.t += dt; S.boost *= Math.pow(0.3, dt); S.rot += dt * (S.speed + S.boost);
    S.discoMix += ((S.disco ? 1 : 0) - S.discoMix) * Math.min(1, dt * 2.2);
    if (Music.isPlaying()) { var ph = Music.phase(); S.pulse = Math.exp(-ph * 5.5); bounce(ph); }
    else if (S.pulse !== 0) { S.pulse = 0; bounce(-1); }
    if (heroVis) { ball.draw(dt); floor.draw(); }
    spots.draw(rootVis);
    playerBars();
    raf = requestAnimationFrame(frame);
  }
  function run() { if (REDUCE || raf || document.hidden) return; last = 0; raf = requestAnimationFrame(frame); }
  function still() { ball.resize(); floor.resize(); ball.draw(0); floor.draw(); }

  if (REDUCE) { still(); spotsCv.style.display = 'none'; }
  else run();

  var rsT = 0;
  window.addEventListener('resize', function () {
    clearTimeout(rsT);
    rsT = setTimeout(function () { ball.resize(); floor.resize(); spots.resize(); if (REDUCE) still(); }, 120);
  });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { if (S.disco) setDisco(false); }
    else run();
  });

  /* Kugel antippen: Glitzer. Fünfmal schnell hintereinander: Disco-Modus. */
  var taps = [];
  $('.id-ballbtn').addEventListener('click', function () {
    S.boost += 4; ball.burst();
    if (REDUCE) still();
    var now = Date.now(); taps.push(now); taps = taps.filter(function (t) { return now - t < 2500; });
    if (taps.length >= 5 && !S.disco) { taps = []; setDisco(true); }
  });

  /* ---------- Disco-Modus und Player ---------- */
  var toggles = $$('.id-disco-toggle');
  var player = $('#id-player'), plPlay = $('#id-pl-play'), plNext = $('#id-pl-next'), plTrack = $('#id-pl-track');
  var aboVis = false, narrow = mq('(max-width: 920px)'), phone = mq('(max-width: 640px)');
  function playerVis() {
    var show = (S.disco || (!heroVis && !phone.matches)) && !(narrow.matches && aboVis);
    player.classList.toggle('is-shown', show);
  }
  function setDisco(on) {
    if (on && !Music.start()) on = false;
    if (!on) Music.stop();
    S.disco = on; S.speed = on ? 0.95 : 0.32; if (on) S.boost += 2.5;
    if (REDUCE) S.discoMix = on ? 1 : 0;
    root.classList.toggle('is-disco', on);
    toggles.forEach(function (b) {
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var s = b.querySelector('span'); if (s) s.textContent = on ? 'Disco mode off' : 'Disco mode on';
    });
    plPlay.setAttribute('aria-pressed', on ? 'true' : 'false');
    plPlay.setAttribute('aria-label', on ? 'Musik pausieren' : 'Musik abspielen');
    if (!on) bounce(-1);
    if (REDUCE) still();
    playerVis(); run();
  }
  Music.onTrack(function (tr) {
    plTrack.innerHTML = tr.name + '<span class="id-pl-bpm"> · ' + tr.bpm + ' BPM</span>';
    root.style.setProperty('--id-bpm', tr.bpm);
  });
  toggles.forEach(function (b) { b.addEventListener('click', function () { setDisco(!S.disco); }); });
  plPlay.addEventListener('click', function () { setDisco(!S.disco); });
  plNext.addEventListener('click', function () { Music.next(); });
  if (!Music.supported) { toggles.forEach(function (b) { b.hidden = true; }); player.hidden = true; var nt = $('.id-note'); if (nt) nt.hidden = true; }

  /* ---------- Sichtbarkeit: Animationen nur, wenn man sie sieht ---------- */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { es.forEach(function (e) { heroVis = e.isIntersecting; }); playerVis(); }, { threshold: 0 }).observe(hero);
    new IntersectionObserver(function (es) { es.forEach(function (e) { rootVis = e.isIntersecting; }); }, { threshold: 0 }).observe(root);
    var once = function (el, cls, th) {
      if (!el) return;
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { el.classList.add(cls); io.disconnect(); } }); }, { threshold: th });
      io.observe(el);
    };
    if (!REDUCE) { once($('#id-record'), 'is-bloom', 0.35); once($('#id-eq'), 'is-live', 0.4); }
    new IntersectionObserver(function (es) { es.forEach(function (e) { aboVis = e.isIntersecting; }); playerVis(); }, { threshold: 0.12 }).observe($('#id-abo'));
  }

  /* ---------- Geschmacksrose: Blätter aus den Noten des Produkts ---------- */
  var ROSEMAP = {"reife feige":["feige"],"brauner zucker":["brauner-zucker"],"dunkle schokolade":["zartbitter"],"zitrus":["zitrone"],"aprikose":["steinobst"],"nuss":["nuss"],"rote früchte":["rote-beeren"],"honig":["honig"],"beeren":["rote-beeren"],"karamell":["karamell"],"erdbeere":["rote-beeren"],"schokolade":["milchschoko"],"fudge":["karamell"],"vanille":["vanille"],"mandel":["nuss"],"steinfrüchte":["steinobst"],"rote beeren":["rote-beeren"],"pfirsich":["steinobst"],"nüsse":["nuss"],"kirschmarmelade":["kirsche","marmelade"],"schwarze johannisbeere":["dunkle-beeren"],"birne":["gruene-frucht"],"limette":["limette"],"butterkeks":["keks"],"haselnuss":["nuss"],"gelbe früchte":["steinobst"],"backgewürze":["gewuerz"],"schwarzer tee":["schwarztee"],"mandarine":["orange"],"grüner apfel":["gruene-frucht"],"jasmin":["blueten"],"nektarine":["steinobst"],"vanille joghurt":["vanille"],"tropenfrüchte":["tropisch"],"maple":["honig"],"orange":["orange"],"milchschokolade":["milchschoko"],"caramel":["karamell"],"feigenmarmelade":["feige","marmelade"],"kokos":["tropisch"],"mango":["tropisch"],"blaubeere":["dunkle-beeren"],"vanillepudding":["vanille"],"kaki":["tropisch"],"ananas":["tropisch"],"senfkörner":["gewuerz"],"pinke pampelmuse":["zitrone"],"maracuja":["tropisch"],"roter apfel":["gruene-frucht"],"toffee":["karamell"],"orangenzeste":["orange"],"kakaonibs":["zartbitter"],"clementine":["orange"],"weiße traube":["traube"],"rohrzucker":["brauner-zucker"],"weiße schokolade":["milchschoko"],"floral":["blueten"],"zitronengras":["zitrone"],"honigmelone":["gruene-frucht"],"panela zucker":["brauner-zucker"],"hagebutte":["hibiskus"],"orangenblüte":["blueten"],"stachelbeere":["gruene-frucht"],"zitronenzeste":["zitrone"],"plattpfirsich":["steinobst"],"rote johannisbeere":["rote-beeren"],"bergamotte":["zitrone"],"kakao":["zartbitter"],"kirsche":["kirsche"],"passionsfrucht":["tropisch"],"sternfrucht":["tropisch"],"litchi":["tropisch"],"zuckerrohr":["brauner-zucker"],"pflaume":["steinobst"],"brombeere":["dunkle-beeren"],"himbeere":["rote-beeren"],"blutorange":["orange"],"lychee":["tropisch"],"honigwabe":["honig"],"annanas":["tropisch"],"ahornsyrup":["honig"],"karamel":["karamell"],"rosenblüte":["blueten"],"zitronenbonbon":["zitrone"],"rhubarb":["gruene-frucht"],"lime":["limette"],"ceylon tea":["schwarztee"],"erdbeermarmelade":["rote-beeren","marmelade"],"ceylon tee":["schwarztee"],"melone":["gruene-frucht"],"rhabarber":["gruene-frucht"],"weißer pfirsich":["steinobst"],"karamell fudge":["karamell"],"grapefruit":["zitrone"],"blumig":["blueten"],"rote traube":["traube"],"holunderblüte":["blueten"],"weingummi":["traube"],"panettone":["keks","rosine"],"bratapfel":["gruene-frucht","gewuerz"],"rote pflaume":["steinobst"],"blaubeermarmelade":["dunkle-beeren","marmelade"],"feige":["feige"],"wassermelone":["gruene-frucht"],"ananas-kombucha":["tropisch"],"tropische früchte":["tropisch"],"lindenblüte":["blueten"],"earl grey":["schwarztee","zitrone"],"himbeerfudge":["rote-beeren","karamell"],"cashew":["nuss"],"granatapfel":["rote-beeren"],"quitte":["gruene-frucht"],"klementine":["orange"],"rote trauben":["traube"],"cranberry":["rote-beeren"],"cherry cola":["kirsche"],"marshmallow":["vanille"],"lemongrass":["zitrone"],"heckenkirsche":["blueten"],"mandarine mit honig":["orange","honig"],"steinfruchtkompott":["steinobst","marmelade"],"weißer tee":["gruentee"],"guave":["tropisch"],"amarenakirsche":["kirsche"],"ganache":["zartbitter"],"weiße blüten":["blueten"],"erdbeermilchshake":["rote-beeren"],"macadamia":["nuss"],"pekan":["nuss"],"melasse":["brauner-zucker"],"orangen schokolade":["zartbitter","orange"],"lavendel":["blueten"],"lila früchte":["dunkle-beeren"],"gewürze":["gewuerz"],"kandierter ingwer":["gewuerz"],"nougat":["nuss","milchschoko"],"löwenzahn bonbons":["blueten"],"rosentee":["blueten","schwarztee"],"oolong tee":["schwarztee"],"rose":["blueten"],"orangenblüten":["blueten"],"kamille":["blueten"],"passionsfruchtjoghurt":["tropisch"],"limettenkefir":["limette"],"lychee martini":["tropisch"],"papaya":["tropisch"],"mango-joghurt":["tropisch"],"limonade":["zitrone"],"hibiskus":["hibiskus"],"hibiscus":["hibiskus"],"süße grapefruit":["zitrone"],"veilchen":["blueten"],"traube":["traube"],"zitrone":["zitrone"],"schokoladenfudge":["milchschoko","karamell"],"reife pflaume":["steinobst"],"kiwi":["gruene-frucht"],"beeren kompott":["rote-beeren","marmelade"],"schwarze kirsche":["kirsche"],"marzipan":["nuss"],"ahornsirup":["honig"],"brombeerkompott":["dunkle-beeren","marmelade"],"heidelbeere":["dunkle-beeren"],"getrocknete aprikose":["steinobst","rosine"],"butterscotch":["karamell"],"pistazie":["nuss"],"vanilla":["vanille"],"traubengelee":["traube","marmelade"],"kumquat":["orange"],"lila traube":["traube"],"zartbitterschokolade":["zartbitter"],"weißertee":["gruentee"],"orangenmarmelade":["orange","marmelade"],"milchbonbon":["karamell"],"erdbeer-daiquiri":["rote-beeren"],"hershey's kiss":["milchschoko"],"macaron":["nuss"],"zuckerplätzchen":["keks"],"gewürzrum":["gewuerz"],"cranberries":["rote-beeren"],"orangen zeste":["orange"],"rote grütze":["rote-beeren","marmelade"],"wilde erdbeeren":["rote-beeren"],"rhabarbermarmelade":["gruene-frucht","marmelade"],"zitronencreme":["zitrone"],"schwarzkirsche":["kirsche"],"orangenschokolade":["zartbitter","orange"],"apfelkuchen":["gruene-frucht","keks"],"zitronensorbet":["zitrone"],"geißblatt":["blueten"],"karamellisierte nüsse":["nuss","karamell"],"feigen":["feige"],"wilder honig":["honig"],"kirschen":["kirsche"],"apfelwein":["gruene-frucht"],"schw. johannisbeere":["dunkle-beeren"],"honeysuckle":["blueten"],"brombeer-fudge":["dunkle-beeren","karamell"],"pfirsich eistee":["steinobst","schwarztee"],"kandierte mandel":["nuss"],"pandan":["vanille"],"parma violet":["blueten"],"litschi":["tropisch"],"mirabelle":["steinobst"],"gelbe pflaume":["steinobst"],"cantaloupe":["gruene-frucht"],"zitronenverbene":["zitrone"],"himbeermarmelade":["rote-beeren","marmelade"],"black cherry":["kirsche"],"caramel fudge":["karamell"],"geröstete mandel":["nuss"],"nashi pear":["gruene-frucht"],"champagnertrüffel":["milchschoko"],"süßes popcorn":["keks"],"glückskeks":["keks"],"kandierte limette":["limette"],"panelazucker":["brauner-zucker"],"kantaloupe":["gruene-frucht"],"grüne traube":["traube"],"holunderblütensirup":["blueten"],"rooibos-tee":["schwarztee"],"hagebuttentee":["hibiskus"],"macadamia nuss":["nuss"],"geröstete haselnuss":["nuss"],"rote weintraube":["traube"],"muscovado zucker":["brauner-zucker"],"karamellkeks":["keks","karamell"],"dunkle schokoladen ganache":["zartbitter"],"lemon curd":["zitrone"],"rum und rosinen":["rosine"],"wein":["traube"],"zitrusfrucht":["zitrone"],"ceylontee":["schwarztee"],"eingemachte früchte":["marmelade"],"eiche":["erdig"],"zimtsterne":["gewuerz","keks"],"kandierter apfel":["gruene-frucht"],"spekulatius":["gewuerz","keks"],"brombeermarmelade":["dunkle-beeren","marmelade"],"limetten-baiser-torte":["limette"],"pomelo":["zitrone"],"apfel":["gruene-frucht"],"blood orange":["orange"],"pumpkin spice latte":["gewuerz"],"nussnougatcreme":["nuss","milchschoko"],"süßkirsche":["kirsche"],"molasses":["brauner-zucker"],"pu'er tee":["schwarztee","erdig"],"pecanuss":["nuss"],"malz":["keks"],"cola":["gewuerz"],"schokoladenkuchen":["milchschoko","keks"],"medjool-dattel":["rosine"],"rosine":["rosine"],"pflaumenmarmelade":["steinobst","marmelade"],"nashi-birne":["gruene-frucht"],"holunderblüten":["blueten"],"kardamom":["gewuerz"],"getrocknete feige":["feige"],"schokoladenmousse":["milchschoko"],"praline":["milchschoko","nuss"],"weiße teeblüten":["blueten","gruentee"],"cantaloupe-melone":["gruene-frucht"],"apfelschorle":["gruene-frucht"],"gesalzenes karamell proteinriegel":["karamell"],"schokoladenmilch":["milchschoko"],"sternenfrucht":["tropisch"],"milky way (der riegel)":["milchschoko"],"mondkuchen":["keks"],"meersalz-karamell":["karamell"],"madeleine":["keks"],"belgische meersfrüchte pralinen":["milchschoko","nuss"],"möhrenkuchen":["keks","gewuerz"],"eierlikör (keine sorge, kein restalkohl)":["vanille"],"schokohase (marke egal)":["milchschoko"],"muskatnuss":["gewuerz"],"schokoladenbrownie":["zartbitter"],"macadamianuss":["nuss"]};
  var FAM = [
    ['Beeren', '#C8324F', [['rote-beeren', 'Rote Beeren'], ['dunkle-beeren', 'Dunkle Beeren'], ['kirsche', 'Kirsche'], ['traube', 'Traube']]],
    ['Zitrus', '#D99A0B', [['orange', 'Orange'], ['zitrone', 'Zitrone'], ['limette', 'Limette']]],
    ['Obst', '#E86F2E', [['steinobst', 'Steinobst'], ['tropisch', 'Tropisch'], ['gruene-frucht', 'Grüne Frucht']]],
    ['Eingekocht', '#8C3A6C', [['rosine', 'Rosine'], ['feige', 'Feige'], ['marmelade', 'Marmelade']]],
    ['Blüte & Tee', '#8A6FCB', [['blueten', 'Blüten'], ['hibiskus', 'Hibiskus'], ['schwarztee', 'Schwarztee'], ['gruentee', 'Grüntee']]],
    ['Süß', '#B9772B', [['brauner-zucker', 'Brauner Zucker'], ['karamell', 'Karamell'], ['honig', 'Honig'], ['vanille', 'Vanille']]],
    ['Kakao & Nuss', '#6E4630', [['milchschoko', 'Milchschoko'], ['zartbitter', 'Zartbitter'], ['nuss', 'Nuss'], ['keks', 'Keks & Malz']]],
    ['Würzig', '#557545', [['gewuerz', 'Gewürze'], ['tabak', 'Tabak'], ['erdig', 'Erdig']]]
  ];
  var LEAF = {};
  FAM.forEach(function (f) { f[2].forEach(function (l) { LEAF[l[0]] = { label: l[1], fam: f[0], color: f[1] }; }); });
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function arc(r0, r1, a0, a1) {
    function pt(r, a) { a = a * Math.PI / 180; return [r * Math.cos(a), r * Math.sin(a)]; }
    var p0 = pt(r1, a0), p1 = pt(r1, a1), p2 = pt(r0, a1), p3 = pt(r0, a0), L = (a1 - a0) > 180 ? 1 : 0, f = function (n) { return n.toFixed(2); };
    return 'M' + f(p0[0]) + ' ' + f(p0[1]) + 'A' + r1 + ' ' + r1 + ' 0 ' + L + ' 1 ' + f(p1[0]) + ' ' + f(p1[1]) + 'L' + f(p2[0]) + ' ' + f(p2[1]) + 'A' + r0 + ' ' + r0 + ' 0 ' + L + ' 0 ' + f(p3[0]) + ' ' + f(p3[1]) + 'Z';
  }
  function renderRose() {
    var rec = $('#id-record'), host = $('#id-rose'), list = $('#id-legend-list');
    if (!rec || !host) return;
    var notes = [];
    try { notes = JSON.parse(rec.getAttribute('data-notes') || '[]'); } catch (e) { notes = []; }
    var sel = {}, hits = [];
    notes.forEach(function (t) {
      var m = ROSEMAP[String(t).toLowerCase().trim()]; hits.push(m || null);
      if (!m) return;
      sel[m[0]] = Math.min(3, (sel[m[0]] || 0) + 2);
      if (m[1]) sel[m[1]] = Math.min(3, (sel[m[1]] || 0) + 1);
    });
    if (!Object.keys(sel).length) { $('.id-recordfig').hidden = true; return; }
    var IN0 = 30, IN1 = 96, OUT0 = 102, BAND = 29, FW = 360 / FAM.length, START = -90 - FW / 2, order = {}, n = 0, out = [];
    out.push('<circle r="238" fill="#0B0D0C"/>');
    for (var r = 193; r < 236; r += 2.6) out.push('<circle r="' + r.toFixed(1) + '" fill="none" stroke="rgba(255,255,255,.05)" stroke-width=".7"/>');
    out.push('<circle r="237" fill="none" stroke="rgba(255,255,255,.14)" stroke-width="1.2"/><circle r="191" fill="none" stroke="rgba(255,243,218,.12)" stroke-width="1"/>');
    FAM.forEach(function (f, fi) { if (f[2].some(function (l) { return sel[l[0]]; })) order[fi] = n++; });
    FAM.forEach(function (f, fi) {
      var a0 = START + fi * FW, w = FW / f[2].length;
      f[2].forEach(function (l, di) {
        var b0 = a0 + di * w + 0.7, b1 = a0 + (di + 1) * w - 0.7, v = sel[l[0]] || 0;
        out.push('<path d="' + arc(OUT0, OUT0 + 3 * BAND, b0, b1) + '" fill="rgba(255,243,218,.045)"/>');
        if (v) out.push('<path class="id-petal" style="--i:' + order[fi] + '" d="' + arc(OUT0, OUT0 + v * BAND, b0, b1) + '" fill="' + f[1] + '" stroke="rgba(255,243,218,.3)" stroke-width=".8"/>');
      });
    });
    FAM.forEach(function (f, fi) {
      var a0 = START + fi * FW, a1 = a0 + FW, lit = order[fi] !== undefined, m = (a0 + a1) / 2, flip = Math.cos(m * Math.PI / 180) < 0;
      out.push('<path class="id-wedge' + (lit ? ' is-lit' : '') + '"' + (lit ? ' style="--i:' + order[fi] + '"' : '') + ' d="' + arc(IN0, IN1, a0 + 0.7, a1 - 0.7) + '" fill="' + f[1] + '" fill-opacity="' + (lit ? 1 : 0.16) + '"/>');
      out.push('<text transform="rotate(' + m.toFixed(2) + ') translate(' + ((IN0 + IN1) / 2 + 1) + ',0)' + (flip ? ' rotate(180)' : '') + '" text-anchor="middle" dominant-baseline="central" font-size="' + (f[0].length > 9 ? 8.6 : 10) + '" font-weight="700" font-family="Jost, Futura, system-ui, sans-serif" fill="' + (lit ? '#FFFFFF' : 'rgba(255,243,218,.5)') + '">' + esc(f[0]) + '</text>');
    });
    out.push('<circle r="' + (IN0 - 4) + '" fill="#E6BD69"/><circle r="3.5" fill="#0B0D0C"/>');
    var label = 'Geschmacksrose von ' + NAME + ': ' + notes.join(', ');
    host.innerHTML = '<svg viewBox="-240 -240 480 480" role="img" aria-label="' + esc(label) + '">' + out.join('') + '</svg>';
    if (list) list.innerHTML = notes.map(function (t, i) {
      var m = hits[i];
      if (!m) return '<li><span class="id-sws"></span><span><b>' + esc(t) + '</b></span></li>';
      var a = LEAF[m[0]], b = m[1] && LEAF[m[1]];
      var sw = '<i class="id-sw" style="background:' + a.color + '"></i>' + (b ? '<i class="id-sw" style="background:' + b.color + '"></i>' : '');
      var txt = b ? a.label + ' (' + a.fam + ') und ' + b.label + ' (' + b.fam + ')' : a.label + ', Familie ' + a.fam;
      return '<li><span class="id-sws">' + sw + '</span><span><b>' + esc(t) + '</b> · ' + esc(txt) + '</span></li>';
    }).join('');
  }
  renderRose();

  /* ---------- Disco Mixer: Geschmack → Regler ---------- */
  var FIX = {
    bitter: { k: { grind: 1, strength: 0, volume: -1 }, d: { grind: 'gröber', strength: 'so lassen', volume: 'weniger' },
      t: '<p><b>Bitter</b> heißt meist: Das Wasser zieht zu viel aus dem Pulver. Stell den Mahlgrad eine Stufe gröber und lass den Espresso kürzer laufen, 25 bis 40 ml reichen.</p><p>Für die große Tasse nimm lieber einen Americano. Und wenn die Brühgruppe länger nicht gespült wurde: Altes Kaffeeöl schmeckt ranzig.</p>' },
    sauer: { k: { grind: -1, strength: 0, volume: 0 }, d: { grind: 'feiner', strength: 'so lassen', volume: 'so lassen' },
      t: '<p><b>Sauer und flach</b> heißt: Das Wasser holt zu wenig raus. Stell den Mahlgrad eine Stufe feiner.</p><p>Nach dem Umstellen braucht die Maschine zwei, drei Tassen, bis du den Unterschied schmeckst.</p>' },
    duenn: { k: { grind: -1, strength: 1, volume: -1 }, d: { grind: 'feiner', strength: 'stärker', volume: 'weniger' },
      t: '<p><b>Wässrig</b> heißt: zu wenig Kaffee für zu viel Wasser. Dreh die Stärke hoch, dann mahlt die Maschine mehr Pulver pro Tasse. Dazu eine Stufe feiner und weniger Wasser.</p><p>Für den großen Becher: Americano statt Lungo.</p>' },
    gut: { k: { grind: 0, strength: 0, volume: 0 }, d: { grind: 'passt', strength: 'passt', volume: 'passt' },
      t: '<p><b>Perfekt.</b> Dann nichts mehr anfassen.</p><p>Damit dir die Bohnen nicht ausgehen: <a href="#id-abo">Stell dir unten dein Abo zusammen.</a></p>' }
  };
  var chips = $$('.id-chip'), knobs = {};
  $$('.id-knob').forEach(function (k) { knobs[k.getAttribute('data-knob')] = { ptr: $('.id-knob-ptr', k), dir: $('.id-knob-dir', k) }; });
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      var f = FIX[c.getAttribute('data-fix')];
      chips.forEach(function (o) { o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
      Object.keys(knobs).forEach(function (n) {
        knobs[n].ptr.style.setProperty('--rot', (f.k[n] * 58) + 'deg');
        knobs[n].dir.textContent = f.d[n];
      });
      $('#id-fixtext').innerHTML = f.t;
    });
  });

  /* ---------- Abo-Konfigurator ---------- */
  var cfg = { size: 250, plan: 'unlimited', every: 2, cups: 2, g: 10 };
  var form = $('#id-config');
  var SIZE_TXT = { 250: '250 g', 1000: '1 kg', 3000: '3 kg' };
  var ORDER = ['unlimited', 'limited6', 'limited12'];
  var PLAN_TXT = { unlimited: 'Unlimited', limited6: 'Limited 6 Monate', limited12: 'Limited 12 Monate' };

  function url(base, vid, sp) { return base + '?variant=' + vid + (sp ? '&selling_plan=' + sp : ''); }
  function has(plan, size) { return !!(D.plans[plan] && D.plans[plan].v[size]); }
  function quote() {
    var P = D.plans[cfg.plan], v = P.v[cfg.size], kg = cfg.size / 1000, sv = D.single.v[cfg.size], single = sv ? sv.price : 0, q = {};
    q.variant = v.id;
    if (cfg.plan === 'unlimited') {
      var price = (P.pp[cfg.size] && P.pp[cfg.size][cfg.every]) || Math.round(v.price * (100 - P.disc) / 100);
      q.plan = P.sp[cfg.every]; q.href = url(P.url, v.id, q.plan);
      q.title = NAME + ' · ' + SIZE_TXT[cfg.size] + ' · Unlimited';
      q.price = eur(price); q.per = 'pro Lieferung, alle ' + cfg.every + ' Wochen'; q.badge = '∞';
      q.bar = eur(price); q.barSub = 'pro Lieferung, alle ' + cfg.every + ' Wochen';
      q.facts = [
        eur(Math.round(price / kg)) + ' pro kg' + (single ? ', im Einzelkauf ' + eur(single) + (cfg.size === 250 ? ' pro Tüte' : cfg.size === 1000 ? ' pro Kilo' : ' pro ' + SIZE_TXT[cfg.size]) : ''),
        (P.disc ? P.disc + ' % Rabatt auf jede Lieferung' : 'Jede Lieferung zum Abo-Preis'),
        'Nach der 3. Lieferung jederzeit kündbar. Lieferungen überspringst du im Kundenkonto.',
        'Versand innerhalb Deutschlands kostenlos'
      ];
    } else {
      var n = P.months, total = v.price, exact = total % n === 0, singleTotal = single * n, save = singleTotal - total;
      q.plan = P.sp; q.href = url(P.url, v.id, q.plan);
      q.title = NAME + ' · ' + SIZE_TXT[cfg.size] + ' · Limited ' + n;
      q.price = eur(total); q.per = 'einmalig für ' + n + ' Lieferungen à ' + SIZE_TXT[cfg.size] + ', eine pro Monat'; q.badge = '×' + n;
      q.bar = eur(total); q.barSub = 'einmalig, ' + n + ' Lieferungen';
      q.facts = [
        (exact ? '' : '≈ ') + eur(Math.round(total / n)) + ' pro Lieferung, ' + eur(Math.round(total / (n * kg))) + ' pro kg',
        single && save > 0 ? 'Du sparst ' + eur(save) + ' (' + Math.round(save / singleTotal * 100) + ' %) gegenüber ' + n + ' Einzelkäufen' : 'Einmal zahlen, ' + n + ' Lieferungen',
        'Endet automatisch nach ' + n + ' Monaten. Kündigen musst du nichts.',
        'Versand innerhalb Deutschlands kostenlos'
      ];
    }
    return q;
  }
  function setRadio(name, val) {
    var el = form.querySelector('input[name="' + name + '"][value="' + val + '"]');
    if (el) el.checked = true;
  }
  function fixState() {
    if (!has(cfg.plan, cfg.size)) {
      var alt = ORDER.filter(function (k) { return has(k, cfg.size); })[0];
      if (alt) cfg.plan = alt;
      else { cfg.size = [250, 1000, 3000].filter(function (sz) { return has(cfg.plan, sz); })[0] || 250; }
    }
    if (cfg.plan === 'unlimited' && !D.plans.unlimited.sp[cfg.every]) cfg.every = +Object.keys(D.plans.unlimited.sp)[0];
  }
  function render() {
    fixState();
    setRadio('id-size', cfg.size); setRadio('id-plan', cfg.plan); setRadio('id-every', cfg.every);
    $$('input[name="id-size"]', form).forEach(function (i) {
      var plans = ORDER.filter(function (k) { return has(k, +i.value); });
      var lab = i.parentNode; lab.hidden = !plans.length;
      var sub = $('.id-opt-sub', lab), base = sub.getAttribute('data-base') || sub.textContent;
      sub.setAttribute('data-base', base);
      sub.textContent = plans.length === 1 && plans.length < ORDER.filter(function (k) { return D.plans[k]; }).length ? base + ', nur ' + PLAN_TXT[plans[0]] : base;
    });
    $$('input[name="id-plan"]', form).forEach(function (i) { i.parentNode.hidden = !D.plans[i.value]; i.disabled = !has(i.value, cfg.size); });
    $$('input[name="id-every"]', form).forEach(function (i) {
      var ok = !!(D.plans.unlimited && D.plans.unlimited.sp[i.value]);
      i.parentNode.hidden = !ok; i.disabled = cfg.plan !== 'unlimited' || !ok;
    });
    var disc = D.plans.unlimited && D.plans.unlimited.disc, us = $('#id-plan-unl-sub');
    if (us) us.textContent = 'läuft, bis du Stopp sagst' + (disc ? ', mit ' + disc + ' % Rabatt' : '');
    $$('.id-opt', form).forEach(function (l) {
      var i = l.querySelector('input');
      l.classList.toggle('is-on', i.checked && !i.disabled);
      l.classList.toggle('is-off', i.disabled);
    });
    var only = ORDER.filter(function (k) { return has(k, cfg.size); });
    $('#id-plan-note').textContent = only.length === 1 && cfg.plan === only[0] && only[0] !== 'unlimited' ? SIZE_TXT[cfg.size] + ' gibt es als ' + PLAN_TXT[only[0]] + '.' : '';
    $('#id-every-note').textContent = cfg.plan === 'unlimited' ? '' : 'Im Limited-Abo kommt jeden Monat eine Lieferung.';
    var q = quote();
    $('#id-r-title').textContent = q.title;
    $('#id-r-price').textContent = q.price;
    $('#id-r-per').textContent = q.per;
    $('#id-r-badge').textContent = q.badge;
    $('#id-r-facts').innerHTML = q.facts.map(function (f) { return '<li>' + f + '</li>'; }).join('');
    var img = $('#id-r-bag'), big = cfg.size >= 1000;
    var src = img.getAttribute(big ? 'data-bag1000' : 'data-bag250');
    if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
    img.setAttribute('alt', NAME + ', ' + (big ? '1-kg-Tüte' : '250-g-Tüte'));
    $('#id-cta').setAttribute('href', q.href);
    var once = $('#id-once'), sv = D.single.v[cfg.size] || D.single.v[250];
    if (sv) once.setAttribute('href', url(D.single.url, sv.id));
    $('#id-abo-bar-price').firstChild.nodeValue = q.bar;
    $('#id-abo-bar-sub').textContent = q.barSub;
    $('#id-cta-msg').textContent = '';
  }
  form.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'id-size') cfg.size = +t.value;
    if (t.name === 'id-plan') cfg.plan = t.value;
    if (t.name === 'id-every') cfg.every = +t.value;
    render();
  });
  form.addEventListener('submit', function (e) { e.preventDefault(); });
  $$('.id-opt input', form).forEach(function (i) {
    i.addEventListener('focus', function () { if (i.matches(':focus-visible')) i.parentNode.classList.add('is-focus'); });
    i.addEventListener('blur', function () { i.parentNode.classList.remove('is-focus'); });
  });

  /* Rechner: Tassen und Stärke → Verbrauch und Vorschlag */
  var calcBest = null;
  function calc() {
    var perDay = cfg.cups * cfg.g, perWeek = perDay * 7, best = null, bs = 1e9;
    var U = D.plans.unlimited, sizes = U ? Object.keys(U.v).map(Number) : [], ws = U ? Object.keys(U.sp).map(Number) : [];
    sizes.forEach(function (s) {
      ws.forEach(function (w) {
        var ratio = (s / w) / perWeek, sc = Math.abs(Math.log(ratio));
        if (ratio < 1) sc *= 1.7;
        if (s === 1000) sc += 0.05;
        if (sc < bs) { bs = sc; best = { s: s, w: w }; }
      });
    });
    calcBest = best;
    if (!best) { $('#id-calc-out').innerHTML = ''; return; }
    var d250 = Math.floor(250 / perDay), d1000 = Math.floor(1000 / perDay);
    var txt = '<p>Das sind etwa <b>' + (Math.round(perWeek / 10) * 10) + ' g pro Woche</b>. Eine 250-g-Tüte reicht dir rund ' + d250 + ' Tage, ein Kilo rund ' + d1000 + ' Tage.</p>';
    txt += '<div class="id-calc-rec"><span class="id-pill" id="id-calc-pill">Passt: ' + SIZE_TXT[best.s] + ' alle ' + best.w + ' Wochen</span><button type="button" class="id-textbtn" id="id-calc-apply">Übernehmen</button></div>';
    if (perWeek > 560 && has('limited6', 3000)) txt += '<p>Mehr als ein Kilo in zwei Wochen? Dann lohnt sich ein Blick auf die 3 kg im Limited-Abo.</p>';
    $('#id-calc-out').innerHTML = txt;
    $('#id-cups').textContent = cfg.cups;
    $('#id-cups-minus').disabled = cfg.cups <= 1;
    $('#id-cups-plus').disabled = cfg.cups >= 8;
  }
  $('#id-cups-minus').addEventListener('click', function () { if (cfg.cups > 1) { cfg.cups--; calc(); } });
  $('#id-cups-plus').addEventListener('click', function () { if (cfg.cups < 8) { cfg.cups++; calc(); } });
  $$('.id-seg button').forEach(function (b) {
    b.addEventListener('click', function () {
      cfg.g = +b.getAttribute('data-g');
      $$('.id-seg button').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
      calc();
    });
  });
  $('#id-calc-out').addEventListener('click', function (e) {
    if (!e.target.closest('#id-calc-apply') || !calcBest) return;
    cfg.size = calcBest.s; cfg.plan = 'unlimited'; cfg.every = calcBest.w;
    render();
    var r = $('.id-screen'); r.animate && r.animate([{ boxShadow: '0 0 0 6px rgba(230,189,105,.6)' }, { boxShadow: '0 0 0 6px rgba(255,243,218,.04)' }], { duration: 900, easing: 'ease-out' });
  });

  /* Warenkorb: im Shop direkt mit Abo-Plan rein, sonst Produktseite */
  function onShop() { return !!(window.Shopify && window.Shopify.shop) && /(^|\.)19grams\.coffee$/.test(location.hostname); }
  $('#id-cta').addEventListener('click', function (e) {
    if (!onShop() || !window.fetch) return;
    e.preventDefault();
    var q = quote(), msg = $('#id-cta-msg'), base = (window.Shopify.routes && window.Shopify.routes.root) || '/';
    msg.textContent = 'Kommt in den Warenkorb …';
    fetch(base + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(q.variant), quantity: 1, selling_plan: Number(q.plan) }] })
    }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () { location.href = base + 'cart'; })
      .catch(function () { msg.textContent = 'Das hat nicht geklappt. Wir bringen dich zur Produktseite.'; location.href = q.href; });
  });

  if (D && D.plans.unlimited) { calc(); render(); }
  else if (D && (D.plans.limited6 || D.plans.limited12)) { cfg.plan = D.plans.limited6 ? 'limited6' : 'limited12'; $('.id-calc').hidden = true; render(); }
  else { var ag = $('.id-abo-grid'); if (ag) ag.hidden = true; var ab = $('.id-abo-bar'); if (ab) ab.hidden = true; }

  /* ---------- Sticky-Elemente unter dem Theme-Header ---------- */
  var hdr = document.querySelector('.shopify-section-header-sticky, .section-header, .shopify-section-header');
  var stT = 0;
  function stickyTop() {
    stT = 0;
    var top = 24, h = document.querySelector('.shopify-section-header-sticky');
    if (h && !h.classList.contains('shopify-section-header-hidden')) { var r = h.getBoundingClientRect(); if (r.bottom > 0 && r.top <= 0.5) top = Math.round(r.bottom) + 16; }
    root.style.setProperty('--id-sticky-top', top + 'px');
  }
  if (hdr) { window.addEventListener('scroll', function () { if (!stT) stT = requestAnimationFrame(stickyTop); }, { passive: true }); stickyTop(); }
})();
